export default __webpack_public_path__ + "static/media/Ares_Desktop.343c76fd.mp4";